export const errorMessageKeys = {
  CustomerNotEligible:
    "Sorry, this account is not eligible to join ASOS.WORLD. If you have any questions, please contact customer care.",
  optInError: "Oops! Something went wrong. Please try again later.",
};
